import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import axios from "axios";
import download from "../../asset/images/partner-download.svg";
import { toast } from "react-toastify";
import { Frenchisee } from "../../Configuration/Frenchisee_URL";
import { decryptData, encryptData, handleDownloadDocument } from "../../CommonMethhods/CommonMethods";
import photoImg from "../../../src/asset/images/img-icon.svg";
import eyeIcon from "../../../src/asset/images/eyeIcon.svg";
import deleteIcon from "../../../src/asset/images/delete-red.svg";
import righttick from "../../../src/asset/images/check-circle-green.svg";

function ComplianceDetailsPreview(props) {
  const storeToken = localStorage.getItem("ssoToken");
  let FrenchiseeId = localStorage.getItem("complianceId");
  let navigate = useNavigate();
  let frenchiseeDatails = props.frenchiseeDatails;
  const [showModal, setShowModal] = useState(false);
  const [rejectionData, setRejectionData] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState();
  const [uploadModalShow, setUploadModalShow] = useState(false)
  const [imageModal, setImageModal] = useState(false)
  const [image, setImage] = useState(null);
  const [bseData, setBseData] = useState(null)
  const [dontData, setDontData] = useState(null)
  const [bseModal, setBseModal] = useState(false)
  const [doNotModal, setDoNotModal] = useState(false);
  const [fileType16, setFileType16] = useState("");
  const [fileType17, setFileType17] = useState("");
  const [fileType18, setFileType18] = useState("");
  const [fileType16Err, setFileType16Err] = useState("");
  const [fileType17Err, setFileType17Err] = useState("");
  const [fileType18Err, setFileType18Err] = useState("");
  const [documentData, setDocumentData] = useState({
    1: { name: "", isAvailable: false, url: "", type: "" },
    2: { name: "", isAvailable: false, url: "", type: "" },
    3: { name: "", isAvailable: false, url: "", type: "" },
    4: { name: "", isAvailable: false, url: "", type: "" },
    5: { name: "", isAvailable: false, url: "", type: "" },
    6: { name: "", isAvailable: false, url: "", type: "" },
    7: { name: "", isAvailable: false, url: "", type: "" },
    8: { name: "", isAvailable: false, url: "", type: "" },
    9: { name: "", isAvailable: false, url: "", type: "" },
    10: { name: "", isAvailable: false, url: "", type: "" },
    11: { name: "", isAvailable: false, url: "", type: "" },
    12: { name: "", isAvailable: false, url: "", type: "" },
    13: { name: "", isAvailable: false, url: "", type: "" },
    14: { name: "", isAvailable: false, url: "", type: "" },
    15: { name: "", isAvailable: false, url: "", type: "" },
    16: { name: "", isAvailable: false, url: "", type: "" },
    17: { name: "", isAvailable: false, url: "", type: "" },
    18: { name: "", isAvailable: false, url: "", type: "" },
    20: { name: "", isAvailable: false, url: "", type: "" },
    21: { name: "", isAvailable: false, url: "", type: "" },
    22: { name: "", isAvailable: false, url: "", type: "" },
    23: { name: "", isAvailable: false, url: "", type: "" },
    24: { name: "", isAvailable: false, url: "", type: "" },
    25: { name: "", isAvailable: false, url: "", type: "" },
    26: { name: "", isAvailable: false, url: "", type: "" },
    27: { name: "", isAvailable: false, url: "", type: "" },

  });

  useEffect(() => {
    getUploadedDocsList()
  }, [])

  const getUploadedDocsList = async () => {
    
    try {
      const getValueList = await axios.get(
        `${Frenchisee.DELETE_FILE}?fid=${FrenchiseeId}&fileType=0`,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${storeToken}`
          },
        }
      );
      const getDocListRes = decryptData(getValueList?.data);
      let getResp = JSON.parse(getDocListRes);
      if (getResp?.status === 0) {
        // setDocList(getResp?.data?.info)
        let docValue = getResp?.data?.info;

        const sampleData = {
          1: { name: "", isAvailable: false, url: "", type: "" },
          2: { name: "", isAvailable: false, url: "", type: "" },
          3: { name: "", isAvailable: false, url: "", type: "" },
          4: { name: "", isAvailable: false, url: "", type: "" },
          5: { name: "", isAvailable: false, url: "", type: "" },
          6: { name: "", isAvailable: false, url: "", type: "" },
          7: { name: "", isAvailable: false, url: "", type: "" },
          8: { name: "", isAvailable: false, url: "", type: "" },
          9: { name: "", isAvailable: false, url: "", type: "" },
          10: { name: "", isAvailable: false, url: "", type: "" },
          11: { name: "", isAvailable: false, url: "", type: "" },
          12: { name: "", isAvailable: false, url: "", type: "" },
          13: { name: "", isAvailable: false, url: "", type: "" },
          14: { name: "", isAvailable: false, url: "", type: "" },
          15: { name: "", isAvailable: false, url: "", type: "" },
          16: { name: "", isAvailable: false, url: "", type: "" },
          17: { name: "", isAvailable: false, url: "", type: "" },
          18: { name: "", isAvailable: false, url: "", type: "" },
          20: { name: "", isAvailable: false, url: "", type: "" },
          21: { name: "", isAvailable: false, url: "", type: "" },
          22: { name: "", isAvailable: false, url: "", type: "" },
          23: { name: "", isAvailable: false, url: "", type: "" },
          24: { name: "", isAvailable: false, url: "", type: "" },
          25: { name: "", isAvailable: false, url: "", type: "" },
          26: { name: "", isAvailable: false, url: "", type: "" },
          27: { name: "", isAvailable: false, url: "", type: "" },

        };
          
        
        for (let i = 0; i <= docValue.length - 1; i++) {
          if (docValue[i]?.type) {
            sampleData[docValue[i]?.type].name = docValue[i]?.fname
            sampleData[docValue[i]?.type].isAvailable = true
            sampleData[docValue[i]?.type].urlVal = docValue[i]?.url
            sampleData[docValue[i]?.type].type = docValue[i]?.type
            // sampleData[docValue[i].type].name = docValue[i]?.dfname
          }

          if (docValue[i]?.type === 16) {
            const storeType = docValue[i]?.fname;
            const fileExtensionType = storeType.split(".").pop().toLowerCase();
            setFileType16(fileExtensionType);
          }
          if (docValue[i]?.type === 17) {
            const storeTypeBse = docValue[i]?.fname;
            const fileExtensionBse = storeTypeBse.split(".").pop().toLowerCase();
            setFileType17(fileExtensionBse);
          }
          if (docValue[i]?.type === 18) {
            const storeTypeDoDont = docValue[i]?.fname;
            const fileExtensionDoDont = storeTypeDoDont.split(".").pop().toLowerCase();
            setFileType18(fileExtensionDoDont);
          }
        }

        setDocumentData(sampleData)
      } else {
        toast.error(getResp?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onHide = () => {
    setShowModal(false);
  };
  
  useEffect(() => {
    // getRejectionReason();
    setSelectedFiles([]);
  }, []);

  function handleNSEUpload(e, type1) {
    if (e?.target?.files && e?.target?.files?.length > 0) {
      const imageVal = e?.target?.files[0];

      if (imageVal) {
        let size = Math.round((imageVal?.size / 1024))
        let fileExtension = imageVal?.name.split('.').pop().toLowerCase();
        setFileType16(fileExtension)
        const fileName = imageVal?.name;

        if (size > 2048) {
          setFileType16Err("File size should be 2MB or less than that.");
          return;
        }
        if (!["png", "jpeg", "jpg", "pdf"].includes(fileExtension)) {
          setFileType16Err("This file format is not supported.");
          return;
        }
        const specialCharRegex = /[^a-zA-Z0-9()._\s-]/;
        if (specialCharRegex.test(fileName)) {
          setFileType16Err("Invalid file name.");
          return;
        }
        setFileType16Err("");
        setImage(imageVal);
        uploadeDocuments(e, type1);
      }
    }

  }
  function handleBseUpload(e, type2) {
    if (e?.target?.files && e?.target?.files?.length > 0) {
      const imageVal = e?.target?.files[0];

      if (imageVal) {
        let size = Math.round((imageVal?.size / 1024))
        let fileExtension = imageVal?.name.split('.').pop().toLowerCase();
        setFileType17(fileExtension)
        const fileName = imageVal?.name;

        if (size > 2048) {
          setFileType17Err("File size should be 2MB or less than that.");
          return;
        }
        if (!["png", "jpeg", "jpg", "pdf"].includes(fileExtension)) {
          setFileType17Err("This file format is not supported.");
          return;
        }
        const specialCharRegex = /[^a-zA-Z0-9()._\s-]/;
        if (specialCharRegex.test(fileName)) {
          setFileType17Err("Invalid file name.");
          return;
        }
        setFileType17Err("");
        setBseData(imageVal);
        uploadeDocuments(e, type2);
      }
    }

  }
  function handleDontUpload(e, type3) {
    
    if (e?.target?.files && e?.target?.files?.length > 0) {
      const imageVal = e?.target?.files[0];

      if (imageVal) {
        let size = Math.round((imageVal?.size / 1024))
        let fileExtension = imageVal?.name.split('.').pop().toLowerCase();
        setFileType18(fileExtension)
        const fileName = imageVal?.name;

        if (size > 2048) {
          setFileType18Err("File size should be 2MB or less than that.");
          return;
        }
        if (!["png", "jpeg", "jpg", "pdf"].includes(fileExtension)) {
          setFileType18Err("This file format is not supported.");
          return;
        }
        const specialCharRegex = /[^a-zA-Z0-9()._\s-]/;
        if (specialCharRegex.test(fileName)) {
          setFileType18Err("Invalid file name.");
          return;
        }
        setFileType18Err("");
        setDontData(imageVal);
        uploadeDocuments(e, type3);
      }
    }

  }

  const getRejectionReason = async () => {
    try {
      const getRejection = await axios.get(
        Frenchisee.REJECT_REASONS,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
          },
        }
      );
      const data = getRejection.data;
      // let dataResp = JSON.parse(data)
      setRejectionData(data.data.rejectReasons);
    } catch (error) {
      console.log(error);
    }
  };

  const rejectedUpdated = async () => {
    let rejPayload = {
      id: parseInt(FrenchiseeId),
      status: -4,
      reason: selectedFiles,
    }
    let encyData = encryptData(JSON.stringify(rejPayload))
    try {
      const getStatus = await axios.put(
        Frenchisee.REJECTION_UPDATED,
        `${encyData}`,
        //   {
        //     id: parseInt(FrenchiseeId),
        // status: -2,
        // reason: selectedFiles,
        //   },

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${storeToken}`,
          },
        }
      );
      const dataVal = decryptData(getStatus.data);
      let dataResp = JSON.parse(dataVal);
      if (dataResp?.data) {
        toast.success(dataResp?.data?.message);
        setShowModal(false);
        navigate("/compliance-dashboard");
      } else {
        setShowModal(true);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message)
    }
  };


  const approvedStatus = async () => {
    let approvePayload = {
      id: parseInt(FrenchiseeId),
      status: 4,
    }
    let payload = encryptData(JSON.stringify(approvePayload))
    try {
      const getValue = await axios.put(
        Frenchisee.REJECTION_UPDATED,
        payload,
        // {
        //   id: parseInt(FrenchiseeId),
        //   status: 2
        // },

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${storeToken}`,
          },
        }
      );
      const data = decryptData(getValue?.data);
      let approveRes = JSON.parse(data);
      if (approveRes?.status === 0) {
        toast.success(approveRes?.data?.message);
        navigate("/compliance-dashboard");
      }
      else {
        toast.error(approveRes?.message)
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message)
    }
  };
  const downloadMultiple = (checked = true) => {
    const selectDownload = document.querySelectorAll(".downloadSelect");
    let selectArray = [];
    for (let item of selectDownload) {
      if (checked) {
        if (item.checked === true) {
          selectArray.push(parseInt(item.value));
        }
      } else {
        selectArray.push(item.value);
      }
    }
    setSelectedFiles(selectArray);
  };
  const getReason = () => {
    downloadMultiple();
  };


  const uploadeDocuments = async (e, type) => {
    try {
      const formData = new FormData();
      formData.append("file", e?.target?.files[0]);
      formData.append("type", type);
      formData.append("fid", FrenchiseeId)

      const getValue = await axios.post(
        `${Frenchisee.GET_ALL_FILE}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`
          },
        }
      );
      const response = decryptData(getValue?.data);
      let decResponse = JSON.parse(response)
      if (decResponse?.status === 0) {
        let object = { isAvailable: true, type: type, urlVal: decResponse?.data?.info?.url };
        setDocumentData({ ...documentData, [type]: object })
        getUploadedDocsList()
      }
      else if (response?.status === 1) {
        toast.error(response?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message)
    }
  };


  const deleteDocuments = async (type) => {
    try {
      const getDeleteData = await axios.delete(
        `${Frenchisee.DELETE_FILE}?fid=${FrenchiseeId}&fileType=${type}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
          }
        }
      );
      const deletedResp = decryptData(getDeleteData?.data);
      let delRep = JSON.parse(deletedResp)
      if (delRep?.status === 0) {
        toast.success(delRep?.data?.message)
        // getApiData();
        getUploadedDocsList()
      }
      else {
        toast.error(delRep?.message);
        setDocumentData([])

      }
    } catch (error) {
      console.log(error);
    }
  };

  // const getApiData = () => {
  //   if (docList.length > 0) {
  //     docList.map((data) => {
  //       setFileNameResp(data?.url)
  //       setFileType(data?.type)
  //     });
  //   }
  // }
  // useEffect(() => {
  //   getApiData();
  // }, [docList])

  const showResponseApprove = (e) => {
    e?.preventDefault();
    const isAllDocumentsAvailable =
      documentData["16"]?.isAvailable ||
      documentData["17"]?.isAvailable ||
      documentData["18"]?.isAvailable;
    if (isAllDocumentsAvailable) {
      approvedStatus();
      setUploadModalShow(false);
    } else {
      toast.error("Please upload all required documents before approving.")
    }
  };

  const handleModal = () => {
    // setUploadModalShow(false);
    setImageModal(true)
  }

  const handleModalBse = () => {
    // setUploadModalShow(false);
    setBseModal(true);
  }

  const doDontModal = () => {
    // setUploadModalShow(false);
    setDoNotModal(true)
  }
  return (
    <>
      <div className="card-box">
        <div className="card-title">
          <h2 className="">Document</h2>
        </div>

        <div className="">
          <div className="">
            <div className="row imgWrapper">
              {frenchiseeDatails &&
                frenchiseeDatails?.file?.map((item) => {
                  return (
                    <>
                      <div key={item?.id} className='col-md-6 bottom-25'>
                        <p className='pdf-label'>
                          {item?.type == "1" ? "GST DOCUMENT" :
                            item?.type == "2" ? "PAN CARD" :
                              item?.type == "3" ? "EDUCATION CERTIFICATE" :
                                item?.type == "4" ? "AADHAR FRONT" :
                                  item?.type == "5" ? "AADHAR BACK" :
                                    item?.type == "6" ? "OFFICE ADDRESS DOCUMENT" :
                                      item?.type == "7" ? "MARRIAGE CERTIFICATE" :
                                        item?.type == "8" ? "NAME CHANGE DOCUMENT" :
                                          item?.type == "9" ? "VOTER ID FRONT SIDE" :
                                            item?.type == "10" ? "VOTER ID BACK SIDE" :
                                              item?.type == "11" ? "PASSPORT" :
                                                item?.type == "12" ? "FIRST WITNESS SIGNATURE" :
                                                  item?.type == "13" ? "SECOND WITNESS SIGNATURE" :
                                                    item?.type == "14" ? "SELFIE UPLOAD" :
                                                      item?.type == "15" ? "CANCELLED CHEQUE" :
                                                        item?.type == "16" ? "NSE CERTIFICATE" :
                                                          item?.type == "17" ? "BSE CERTIFICATE" :
                                                            item?.type == "18" ? "DOs & DONTs CERTIFICATE" :
                                                              item?.type == "20" ? "ESIGN BSE AGREEMENT" :
                                                                item?.type == "21" ? "ESIGN BSE ANNEXURE" :
                                                                  item?.type == "22" ? "ESIGN BSE UNDERTAKING" :
                                                                    item?.type == "23" ? "ESIGN NSE AGREEMENT" :
                                                                      item?.type == "24" ? "ESIGN NSE ANNEXURE" :
                                                                        item?.type == "25" ? "ESIGN TERM SHEET" :
                                                                          item?.type == "26" ? "ESIGN INTERNAL AGREEMENT" :
                                                                            item?.type == "27" ? "WELCOME LETTER" : null}</p>
                        <div className='document-wrapper'>

                          {item?.fname?.split(".")[1] === 'pdf' ? (
                            < iframe src={item?.url}
                              className="document-pdf partner-down" />
                          )
                            :
                            (
                              <img src={item?.url} className='document-img'
                                alt='document-img' />
                            )
                          }
                          <img src={download} alt="" className="download-img partner-down"
                            onClick={() => {
                              handleDownloadDocument(item?.url)
                            }} />
                        </div>
                      </div>
                    </>
                  );
                })}
            </div>
          </div>
        </div>
        {frenchiseeDatails?.statusId === 3 ? (
          <div className="partner-btn">
            <div>
              <button
                className="upload-btn"
                type="submit"
                onClick={() => setUploadModalShow(true)}
              >
                UPLOAD
              </button>
            </div>
            <div>
              <button
                className="rej-btn"
                type="submit"
                onClick={() => setShowModal(true)}
              >
                REJECT
              </button>
            </div>
            <div>
              <button
                className="back-btn"
                type="submit"
                onClick={() => {
                  navigate("/compliance-dashboard");
                }}
              >
                BACK
              </button>
            </div>
          </div>
        ) : (
          <div>
            <button
              className="back-btn"
              type="submit"
              onClick={() => {
                navigate("/compliance-dashboard");
              }}
            >
              Back
            </button>
          </div>
        )}
      </div>
      <Modal
        show={showModal}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model partner-modal-rejection"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h2 className="model-title">Rejection Selection</h2>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="reject-modal">
            <h3 className="rejection-modal">Your application has been rejected.</h3>

            <ul className="partner-ul">
              {rejectionData &&
                rejectionData?.map((item) => {
                  return (
                    <>
                      <li>
                        <input
                          type="checkbox"
                          id="resons"
                          value={item.id}
                          className="downloadSelect"
                          onClick={() => getReason()}
                        />
                        <label>{item.reason}</label>
                      </li>
                    </>
                  );
                })}
            </ul>
            <button
              type="submit"
              className="rej-btn reject-comp"
              onClick={() => rejectedUpdated()}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={uploadModalShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model partner-modal-upload"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <form autoComplete="off">
            <div className="body-wrapper">
              <h4 className="text-heading">Upload Document</h4>
              <span className="icon-close" onClick={() => setUploadModalShow(false)}></span>
            </div>
            <ul className="upload-certificate">
              {
                frenchiseeDatails?.nseFnO === true || frenchiseeDatails?.nseCapMarket === true ?
                  <div className="list-col">
                    <div className="form-group pan-input custom-suggest partner-form">
                      <>

                        <div className="pan-data">
                          <div className="label-wrapper">
                            <label className="doc-text">
                              NSE Certificate
                              {/* <span className="mandatory-label">*</span> */}
                            </label>
                            {documentData["16"]?.isAvailable ? (
                              <label className="green-text">
                                Uploaded
                                <img
                                  src={righttick}
                                  alt="check_circle"
                                />
                              </label>
                            ) : (
                              ""
                            )}
                          </div>
                          <div>
                            {documentData["16"]?.isAvailable ? (
                              ""
                            ) : (
                              <span className="info-text">
                                Document should be 2MB and in .jpeg, .jpg, .png & pdf format.
                              </span>
                            )}
                          </div>
                          {documentData["16"]?.isAvailable ? (
                            <div className="doc-uploaded">
                              <div className="doc-text">
                                <div className="check-image">
                                  <span className="file-wrap">
                                    <img
                                      src={photoImg}
                                      alt="document-pic"
                                    />
                                    <label className="img-name">
                                      {documentData["16"]?.name ||
                                        image?.name}
                                    </label>
                                  </span>

                                  <div className="wrap-del-preview">
                                    <button
                                      type="button"
                                      onClick={() => deleteDocuments("16")}
                                      className="del-btn"
                                    >
                                      <img
                                        src={deleteIcon}
                                        alt="delete icon"
                                      />
                                      Delete
                                    </button>

                                    <div className="preview-text">
                                      <span
                                        className="icon-text"
                                        type="button"
                                        onClick={handleModal}
                                      >
                                        <img
                                          src={eyeIcon}
                                          alt="eye icon"
                                        />
                                        Preview
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : fileType16Err ? (
                            <div className="image" id="uploadimg">
                              <span className="forget-link wrong-format doc-error">
                                {fileType16Err}
                              </span>
                            </div>
                          ) : null}
                        </div>

                        <div className="buttons-partner">
                          <input
                            type="file"
                            id="pan"
                            name="pan"
                            accept="image/png, image/jpeg, image/jpg, application/pdf"
                            className="pan-form"
                            onChange={(e) => handleNSEUpload(e, 16)}
                            key={image?.name || ""}
                          />
                          {documentData["16"]?.isAvailable ? (
                            <label className="disable-btn">
                              Choose File
                            </label>
                          ) : (
                            <label for="pan">Choose File</label>
                          )}
                        </div>
                      </>
                    </div>
                  </div>
                  : null
              }


              {
                frenchiseeDatails?.bseFno === true || frenchiseeDatails?.bseCapMarket === true ?

                  <div className="list-col">
                    <div className="form-group pan-input custom-suggest partner-form">
                      <>
                        <div className="pan-data">
                          <div className="label-wrapper">
                            <label className="doc-text">
                              BSE Certificate
                              {/* <span className="mandatory-label">*</span> */}
                            </label>
                            {documentData["17"]?.isAvailable ? (
                              <label className="green-text">
                                Uploaded
                                <img
                                  src={righttick}
                                  alt="check_circle"
                                />
                              </label>
                            ) : (
                              ""
                            )}
                          </div>
                          <div>
                            {documentData["17"]?.isAvailable ? (
                              ""
                            ) : (
                              <span className="info-text">
                                Document should be 2MB and in .jpeg, .jpg, .png & pdf format.
                              </span>
                            )}
                          </div>
                          {documentData["17"]?.isAvailable ? (
                            <div className="doc-uploaded">
                              <div className="doc-text">
                                <div className="check-image">
                                  <span className="file-wrap">
                                    <img
                                      src={photoImg}
                                      alt="document-pic"
                                    />
                                    <label className="img-name">
                                      {documentData["17"]?.name ||
                                        bseData?.name}
                                    </label>
                                  </span>

                                  <div className="wrap-del-preview">
                                    <button
                                      type="button"
                                      onClick={() => deleteDocuments("17")}
                                      className="del-btn"
                                    >
                                      <img
                                        src={deleteIcon}
                                        alt="delete icon"
                                      />
                                      Delete
                                    </button>

                                    <div className="preview-text">
                                      <span
                                        className="icon-text"
                                        type="button"
                                        onClick={handleModalBse}
                                      >
                                        <img
                                          src={eyeIcon}
                                          alt="eye icon"
                                        />
                                        Preview
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : fileType17Err ? (
                            <div className="image" id="uploadimg">
                              <span className="forget-link wrong-format doc-error">
                                {fileType17Err}
                              </span>
                            </div>
                          ) : null}
                        </div>

                        <div className="buttons-partner">
                          <input
                            type="file"
                            id="bse"
                            name="files"
                            accept="image/png, image/jpeg, image/jpg, application/pdf"
                            className="pan-form"
                            onChange={(e) => handleBseUpload(e, 17)}
                            key={bseData?.name || ""}
                          />
                          {documentData["17"]?.isAvailable ? (
                            <label className="disable-btn">
                              Choose File
                            </label>
                          ) : (
                            <label for="bse">Choose File</label>
                          )}
                        </div>
                      </>
                    </div>
                  </div>
                  : null
              }

              <div className="list-col">
                <div className="form-group pan-input custom-suggest partner-form">
                  <>
                    <div className="pan-data">
                      <div className="label-wrapper">
                        <label className="doc-text">
                          DO and DON'T Certificate
                        </label>
                        {documentData["18"]?.isAvailable ? (
                          <label className="green-text">
                            Uploaded
                            <img
                              src={righttick}
                              alt="check_circle"
                            />
                          </label>
                        ) : (
                          ""
                        )}
                      </div>
                      <div>
                        {documentData["18"]?.isAvailable ? (
                          ""
                        ) : (
                          <span className="info-text">
                            Document should be 2MB and in .jpeg, .jpg, .png & pdf format.
                          </span>
                        )}
                      </div>
                      {documentData["18"]?.isAvailable ? (
                        <div className="doc-uploaded">
                          <div className="doc-text">
                            <div className="check-image">
                              <span className="file-wrap">
                                <img
                                  src={photoImg}
                                  alt="document-pic"
                                />
                                <label className="img-name">
                                  {documentData["18"]?.name ||
                                    dontData?.name}
                                </label>
                              </span>

                              <div className="wrap-del-preview">
                                <button
                                  type="button"
                                  onClick={() => deleteDocuments("18")}
                                  className="del-btn"
                                >
                                  <img
                                    src={deleteIcon}
                                    alt="delete icon"
                                  />
                                  Delete
                                </button>

                                <div className="preview-text">
                                  <span
                                    className="icon-text"
                                    type="button"
                                    onClick={doDontModal}
                                  >
                                    <img
                                      src={eyeIcon}
                                      alt="eye icon"
                                    />
                                    Preview
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : fileType18Err ? (
                        <div className="image" id="uploadimg">
                          <span className="forget-link wrong-format doc-error">
                            {fileType18Err}
                          </span>
                        </div>
                      ) : null}
                    </div>

                    <div className="buttons-partner">
                      <input
                        type="file"
                        id="dont"
                        name="pan"
                        accept="image/png, image/jpeg, image/jpg, application/pdf"
                        className="pan-form"
                        onChange={(e) => handleDontUpload(e, 18)}
                        key={dontData?.name || ""}
                      />
                      {documentData["18"]?.isAvailable ? (
                        <label className="disable-btn">
                          Choose File
                        </label>
                      ) : (
                        <label for="dont">Choose File</label>
                      )}
                    </div>
                  </>
                </div>
              </div>

            </ul>
            <div className="upload-modal-wrapper">
              <div>
                <button
                  className="appro-btn"
                  type="submit"
                  onClick={(e) => showResponseApprove(e)}
                >
                  APPROVE
                </button>
              </div>
              <div>
                <button
                  className="back-btn"
                  type="button"
                  onClick={() => setUploadModalShow(false)}
                >
                  CANCEL
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal >

      {/* nse modal start */}
      <Modal
        show={imageModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="ifscModal preview-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setImageModal(false)}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>

          <form className="modal-form select-new">
            <div className="form-group ">
              {/* {
                documentData["16"]?.isAvailable ?
                  <iframe src={documentData["16"]?.urlVal}
                    title="pdf show"
                    frameBorder="0"
                    width="100%"
                    height="100%"
                    allowFullScreen="allowfullscreen"
                    style={{ border: "0" }}>
                  </iframe>
                  : ""
              } */}

              {documentData["16"]?.isAvailable ? (
                fileType16 === "pdf" ? (
                  <iframe
                    id="iframeId"
                    className="preview-iframe"
                    content="text"
                    src={documentData["16"]?.urlVal}
                    title="pdf show"
                    frameBorder="0"
                    allowFullScreen="allowfullscreen"
                    style={{ border: "0" }}
                  ></iframe>
                ) : (
                  <>
                    {documentData["16"]?.urlVal && (
                      <img
                        src={documentData["16"]?.urlVal}
                        alt="Preview"
                        className="preview-image"
                      />
                    )}
                  </>
                )
              ) : (
                ""
              )}
            </div>

          </form>
        </Modal.Body>
      </Modal>
      {/* nse modal  end*/}
      {/* bse modal start  */}
      <Modal
        show={bseModal}
        // onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="ifscModal preview-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setBseModal(false)}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>

          <form className="modal-form select-new">
            <div className="form-group ">

              {documentData["17"]?.isAvailable ? (
                fileType17 === "pdf" ? (
                  <iframe
                    id="iframeId"
                    className="preview-iframe"
                    content="text"
                    src={documentData["17"]?.urlVal}
                    title="pdf show"
                    frameBorder="0"
                    allowFullScreen="allowfullscreen"
                    style={{ border: "0" }}
                  ></iframe>
                ) : (
                  <>
                    {documentData["17"]?.urlVal && (
                      <img
                        src={documentData["17"]?.urlVal}
                        alt="Preview"
                        className="preview-image"
                      />
                    )}
                  </>
                )
              ) : (
                ""
              )}
            </div>

          </form>
        </Modal.Body>
      </Modal>
      {/* bse modal end */}
      {/* do not  modal start */}
      <Modal
        show={doNotModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="ifscModal preview-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setDoNotModal(false)}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>

          <form className="modal-form select-new">
            <div className="form-group ">

              {documentData["18"]?.isAvailable ? (
                fileType18 === "pdf" ? (
                  <iframe
                    id="iframeId"
                    className="preview-iframe"
                    content="text"
                    src={documentData["18"]?.urlVal}
                    title="pdf show"
                    frameBorder="0"
                    allowFullScreen="allowfullscreen"
                    style={{ border: "0" }}
                  ></iframe>
                ) : (
                  <>
                    {documentData["18"]?.urlVal && (
                      <img
                        src={documentData["18"]?.urlVal}
                        alt="Preview"
                        className="preview-image"
                      />
                    )}
                  </>
                )
              ) : (
                ""
              )}

            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* do not modal end */}
    </>
  );
}

export default ComplianceDetailsPreview;
